import type { MaybeRefOrGetter } from 'vue'

import type { ExperienceQueryPartition } from '@common/experience-runtime/utils/create-experience-query-partition'

import { useEventsQueryStore } from '../stores/events.query-store'

export const useEvents = (queryKeyPrefix?: MaybeRefOrGetter<ExperienceQueryPartition | undefined>) => {
  const queryStore = useEventsQueryStore(queryKeyPrefix)

  return {
    fetchPortalEventsQuery: queryStore.fetchPortalEventsQuery,
    fetchPortalDirectoryQuery: queryStore.fetchPortalDirectoryQuery,
    fetchEventDetailQuery: queryStore.fetchEventDetailQuery,
    fetchEventScheduleQuery: queryStore.fetchEventScheduleQuery,
    fetchEventSpeakerScheduleQuery: queryStore.fetchEventSpeakerScheduleQuery,
    fetchEventSpeakersQuery: queryStore.fetchEventSpeakersQuery,
    fetchEventAttendeesQuery: queryStore.fetchEventAttendeesQuery,
    fetchEventTicketsQuery: queryStore.fetchEventTicketsQuery,
    fetchEventExhibitorsQuery: queryStore.fetchEventExhibitorsQuery,
    fetchEventExhibitorMembersQuery: queryStore.fetchEventExhibitorMembersQuery,
    updateSavedSession: queryStore.updateSavedSession,
  }
}
